/* Svensk katalog for locale-closing-annual-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  "clo.importedArchiveTitle": "Importerat årsunderlag",
  "clo.importedArchiveHelp": "Året visar historik från det tidigare systemet. Kontrollera beloppen i rapporterna. Nytt bokslut kräver komplett bokföringsunderlag. Importen styrker inte inlämning.",
  "clo.importedArchiveResult": "Resultat för {year}: {amount}",

  'clo.incompleteBasisTitle': 'Redovisningsunderlaget är ofullständigt',
  'clo.incompleteBasisText': 'Bokslutet är spärrat tills journaltäckningen är komplett. Befintliga dokument är fortfarande tillgängliga från verifikations- och dokumentvyerna.',
  'clo.finalReview.title': 'Förutsättningar och slutkontroll',
  'clo.finalApproval.title': 'Samlat slutgodkännande',
  'clo.finalApproval.bank': 'Bank- och lageravstämning',
  'clo.finalApproval.gainLoss': 'Redovisningsmässig och skattemässig vinst/förlust',
  'clo.finalApproval.differences': 'Permanenta och temporära skillnader',
  'clo.finalApproval.assumptions': 'Förutsättningar och manuella åsidosättanden',
  'clo.finalApproval.confirm': 'Jag har kontrollerat underlaget och godkänner att året avslutas. Godkännare och tidpunkt sparas i historiken.',
  'clo.finalApproval.button': 'Godkänn och avsluta året',
  'clo.finalApproval.statement': 'Jag har kontrollerat bokföring, avstämningar, skatt, årsredovisning och dokumenterade förutsättningar.',
  'clo.finalApproval.audit': 'Godkänt av {name} {time}.',
  'clo.finalApproval.required': 'Samlat slutgodkännande krävs innan året kan avslutas.',
  'clo.closed.subtitleTaxPendingWithoutAnnual': 'Räkenskapsåret är avslutat. Fortsätt med skattemeldingen.',
  'clo.status.ready': 'Klar',
  'clo.status.needsTreatment': 'Behöver hanteras',
  'clo.status.notApplicable': 'Ej aktuellt',
  'clo.group.chart': 'Kontoplan',
  'clo.group.equity': 'Aktiekapital och eget kapital',
  'clo.group.bank': 'Bank',
  'clo.group.cash': 'Mynt och sedlar',
  'clo.group.vat': 'Moms',
  'clo.group.purchases': 'Inköp och verifikationer',
  'clo.group.sales': 'Försäljning och kunder',
  'clo.group.payroll': 'Lön och pension',
  'clo.group.assets': 'Varulager, tillgångar och investeringar',
  'clo.group.periodisation': 'Rätt år och möjliga krav',
  'clo.group.final': 'Skatt, årsredovisning och avslut',
  'clo.periodisation.title': 'Rätt år och möjliga krav',
  'clo.periodisation.subtitle': 'Kontrollera om intäkter och utgifter hör till rätt år och om verksamheten har oklara krav eller förpliktelser för {{year}}.',
  'clo.periodisation.unsupported': 'Denna kontroll stöder norska redovisningsprofiler från 2022. Land, företagsform eller redovisningsramverk måste bedömas särskilt.',
  'clo.periodisation.stale': 'Redovisningsunderlaget har ändrats. Kontrollera bedömningarna på nytt innan du sparar.',
  'clo.periodisation.unresolved': 'Det finns dokumenterade olösta förhållanden. Bokför eller klargör dem innan gruppen kan bli klar.',
  'clo.periodisation.reviewRequired': 'Bekräfta de två kontrollerna nedan innan året avslutas.',
  'clo.periodisation.reconciled': 'Intäkter, utgifter och möjliga krav har gåtts igenom utan olösta förhållanden.',
  'clo.periodisation.unavailable': 'Kontrollunderlaget kunde inte laddas.',
  'clo.periodisation.sectionTitle': 'Intäkter och utgifter runt nyår',
  'clo.periodisation.sectionHelp': 'Kontrollera om försäljning, inköp, förskott eller arbete utan faktura hör till {{year}} eller nästa år. Datumet ensamt ger inte alltid svaret.',
  'clo.periodisation.reviewed': 'Jag har kontrollerat detta, även förhållanden som inte finns i Plumme.',
  'clo.periodisation.optionalNote': 'Lägg till detaljer (valfritt)',
  'clo.periodisation.cutOffReviewed': 'Jag har kontrollerat att försäljning och inköp runt nyår hör till rätt år.',
  'clo.periodisation.prepaymentsReviewed': 'Jag har kontrollerat betalningar som avser nästa år, till exempel abonnemang eller hyra.',
  'clo.periodisation.accrualsReviewed': 'Jag har kontrollerat kostnader och intäkter för året även om fakturan kommer senare.',
  'clo.periodisation.unbilledRevenueReviewed': 'Jag har kontrollerat arbete som har levererats men ännu inte fakturerats.',
  'clo.periodisation.documentationNote': 'Vilka verifikationer eller avtal har du kontrollerat?',
  'clo.periodisation.documentationHelp': 'Skriv gärna vilka verifikationer eller avtal du kontrollerade.',
  'clo.periodisation.unresolvedIssues': 'Är något fortfarande bokfört på fel år eller inte klargjort?',
  'clo.periodisation.foundDocuments': 'Plumme hittade {{count}} verifikationer runt nyår som du kan kontrollera. Referenserna sparas automatiskt med genomgången.',
  'clo.periodisation.foundHelp': 'Listan visar möjliga kontrollpunkter, inte fel. Leveransdatum kan skilja sig från fakturadatum.',
  'clo.periodisation.showDocuments': 'Visa verifikationerna',
  'clo.periodisation.sale': 'försäljning',
  'clo.periodisation.purchase': 'inköp',
  'clo.periodisation.issueSummary': 'Olösta periodiseringar',
  'clo.periodisation.notAnswered': 'Inte besvarad',
  'clo.periodisation.noUnresolved': 'Nej',
  'clo.periodisation.hasUnresolved': 'Ja',
  'clo.periodisation.openPosting': 'Öppna fri kontering',
  'clo.periodisation.postingDescription': 'Periodisering vid bokslut',
  'clo.periodisation.save': 'Spara genomgång',
  'clo.periodisation.saved': 'Genomgången har sparats. Statusen följer dokumentationen och redovisningsunderlaget.',
  'clo.periodisation.saveError': 'Det gick inte att spara genomgången.',
  'clo.periodisation.refresh': 'Läs in uppdaterat underlag',
  'clo.periodisation.back': 'Tillbaka till bokslut',
  'clo.periodisation.plansTitle': 'Periodiseringsplaner',
  'clo.periodisation.plansHelp': 'Bokför först inköpet på ett konto för förutbetalda kostnader. Plumme flyttar därefter kostnaden månad för månad utan att bokföra bank eller leverantörsskuld på nytt.',
  'clo.periodisation.sourcePurchase': 'Bokfört inköp',
  'clo.periodisation.selectPurchase': 'Välj inköp',
  'clo.periodisation.startDate': 'Första period',
  'clo.periodisation.periodCount': 'Antal månader',
  'clo.periodisation.prepaidAccount': 'Konto för förutbetalt',
  'clo.periodisation.costAccount': 'Kostnadskonto',
  'clo.periodisation.planNote': 'Dokumentation',
  'clo.periodisation.createPlan': 'Skapa periodiseringsplan',
  'clo.periodisation.noPlans': 'Inga periodiseringsplaner för detta år.',
  'clo.periodisation.posted': 'bokfört',
  'clo.periodisation.remaining': 'återstår',
  'clo.periodisation.postThrough': 'Bokför till och med',
  'clo.periodisation.postPeriods': 'Bokför perioder',
  'clo.periodisation.changeFuturePlan': 'Ändra framtida plan',
  'clo.periodisation.nextDate': 'Nästa period',
  'clo.periodisation.remainingPeriods': 'Återstående månader',
  'clo.periodisation.changeReason': 'Motivering',
  'clo.periodisation.cancelPlan': 'Avsluta framtida plan',
  'clo.periodisation.cancelReason': 'Motivering',
  'clo.periodisation.planSaveError': 'Det gick inte att spara periodiseringsplanen.',
  'clo.periodisation.planCreated': 'Periodiseringsplanen har skapats.',
  'clo.periodisation.planPosted': 'Förfallna perioder har bokförts.',
  'clo.periodisation.planRevised': 'Den framtida planen har uppdaterats.',
  'clo.periodisation.planCancelled': 'Den framtida planen har avslutats.',
  'clo.reopenReasonRequired': 'Beskriv varför räkenskapsåret ska öppnas igen.',
  'clo.reopenConfirm': 'Öppna året igen',
  'clo.reopenWarning': 'Återöppning häver låset och markerar senare bokslut för ny kontroll. Åtgärden loggas.',
  'clo.reopenReason': 'Motivering',
  'clo.reopenReasonPlaceholder': 'Till exempel: korrigering av periodisering efter mottagen dokumentation',
  'clo.provisions.sectionTitle': 'Möjliga krav och kostnader',
  'clo.provisions.sectionHelp': 'Kontrollera om något som hände före nyår kan ge verksamheten en kostnad senare, till exempel en tvist eller garanti.',
  'clo.provisions.reviewed': 'Jag har kontrollerat om sådana förhållanden finns, även utanför Plumme.',
  'clo.provisions.optionalNote': 'Lägg till detaljer (valfritt)',
  'clo.provisions.obligationsReviewed': 'Jag har kontrollerat om verksamheten kan vara skyldig pengar på grund av något som redan har hänt.',
  'clo.provisions.estimatesReviewed': 'Jag har noterat belopp och osäkerhet för sådana ärenden, om de finns.',
  'clo.provisions.contingenciesReviewed': 'Jag har kontrollerat garantier, tvister och andra möjliga krav.',
  'clo.provisions.documentationNote': 'Vad har du kontrollerat?',
  'clo.provisions.documentationHelp': 'Skriv kort vilka avtal, ärenden eller andra källor du har kontrollerat. Skriv också om inga sådana förhållanden är kända.',
  'clo.provisions.unresolvedIssues': 'Finns det möjliga krav eller kostnader som fortfarande måste bedömas?',
  'clo.provisions.issueSummary': 'Olösta avsättningar eller bedömningar',
  'clo.provisions.postingDescription': 'Avsättning vid bokslut',
  'clo.pension.title': 'Pensionsbetalning (OTP)',
  'clo.pension.subtitle': 'Klargör och stäm av pension för inkomståret {{year}}.',
  'clo.pension.unsupported': 'OTP-kontrollen stöder norska redovisningsprofiler från 2022. Detta år eller redovisningsupplägget måste bedömas särskilt.',
  'clo.pension.incomplete': 'Löneunderlaget saknar giltiga bokförda pensionsbelopp eller betalningsdata. Kontrollera lönekörningarna.',
  'clo.pension.drafts': 'Året har oklara löneutkast. Klargör dem innan OTP-kontrollen kan bli klar.',
  'clo.pension.stale': 'Underlaget har ändrats. Kontrollera dokumentationen på nytt innan du sparar en ny bedömning.',
  'clo.pension.conflict': 'Registrerad pensionsaktivitet måste stämmas av och kan inte sättas till ej aktuellt.',
  'clo.pension.notApplicable': 'Dokumenterad bedömning: OTP är inte aktuellt för detta inkomstår.',
  'clo.pension.noRecordedActivity': 'Inga anställda, löner, pensioner eller relevanta konteringar har registrerats för året. OTP-kontrollen är inte aktuell utifrån uppgifterna i Plumme. Om verksamheten har haft anställda eller pension i ett annat system måste uppgifterna gås igenom.',
  'clo.pension.manualReview': 'Bedöm OTP manuellt',
  'clo.pension.reconciled': 'Pensionsunderlag, betalningar och saldo är dokumenterat avstämda för inkomståret.',
  'clo.pension.reviewRequired': 'OTP-bedömningen är inte klar. Du kan spara nu och slutföra när du har årsbeskedet.',
  'clo.pension.basisTitle': 'Registrerat pensionsunderlag',
  'clo.pension.showRuns': 'Visa {{count}} lönekörningar och betalningsdetaljer',
  'clo.pension.configuredProvider': 'Registrerad leverantör i löneinställningarna: {{name}}. Kontrollera mot årsbeskedet för detta år.',
  'clo.pension.signal.staffingRule': 'Registrerade löner och tjänstgöringsgrader pekar mot OTP-plikt. Plumme har valt «Ja», men saknar oberoende bekräftelse av lönevillkor och medlemskap.',
  'clo.pension.signal.recordedPension': 'Pensionsaktivitet är registrerad i Plumme och måste gås igenom.',
  'clo.pension.signal.unknown': 'Plumme kan inte avgöra OTP-plikt säkert utifrån de registrerade uppgifterna. Avsaknad av lön är ensamt inget undantag.',
  'clo.pension.prefillHelp': 'Förslagen nedan kommer från Plumme, inte från pensionsleverantörens årsbesked. Kontrollera dem mot årsbeskedet innan avstämningen bekräftas.',
  'clo.pension.accountantReview': 'Avancerad kontroll (valfri)',
  'clo.pension.externalPostings': 'Pension har också bokförts utanför lön. Plumme kan inte föreslå fullständiga premiebelopp här; kontrollera bokföringen och årsbeskedet.',
  'clo.pension.statementQuestion': 'Stämmer anställda och belopp i pensionsleverantörens årsbesked med Plumme?',
  'clo.pension.statementUnchecked': 'Inte kontrollerat ännu',
  'clo.pension.statementMatches': 'Ja, årsbeskedet stämmer',
  'clo.pension.statementDiffers': 'Nej, beloppen skiljer sig',
  'clo.pension.needsFurtherReview': 'Bedömningen kan sparas nu, men dessa uppgifter måste klargöras innan OTP kan markeras som klar.',
  'clo.pension.basisHelp': 'Uppskattningarna kommer från bokförda lönekörningar under inkomståret. Betalningarna följer faktiskt betalningsdatum och kan avse tidigare löneår. Detta är inte ett fullständigt saldo på konto 2930, som också kan innehålla skuld för löner.',
  'clo.pension.accrued': 'Bokförd OTP-uppskattning från årets löner',
  'clo.pension.paid': 'Registrerad pensionspremie betald under året',
  'clo.pension.noPayment': 'Ingen pensionsbetalning registrerad',
  'clo.pension.noRuns': 'Inga relevanta bokförda lönekörningar. Det avgör inte ensamt om OTP är aktuellt.',
  'clo.pension.unpaidAtYearEnd': '{{count}} lönekörningar har pensionsuppskattning utan registrerad betalning senast 31.12. Dokumentera eventuell restskuld och betalning efter årsskiftet.',
  'clo.pension.openPayments': 'Öppna pensionsbetalningar',
  'clo.pension.paymentScope': 'Pensionsbetalningar kopplade till löneunderlag eller betalningar under {{year}}. Använd det faktiska betalningsdatumet, även vid betalning efter årsskiftet.',
  'clo.pension.back': 'Tillbaka till OTP-avstämningen',
  'clo.pension.backToClosing': 'Tillbaka till bokslut',
  'clo.pension.reviewTitle': 'Bedömning och dokumentation',
  'clo.pension.applicabilityHelp': 'Bedöm anställningsförhållandena och pensionsordningen för året som avslutas. Dagens leverantörsinställning eller avsaknad av lönekörningar bevisar inte att företaget är undantaget.',
  'clo.pension.rules': 'Se Skatteetatens vägledning',
  'clo.pension.applicability': 'Är OTP aktuellt för inkomståret?',
  'clo.pension.undecided': 'Inte klargjort',
  'clo.pension.applicable': 'Ja – pension ska stämmas av',
  'clo.pension.notApplicableChoice': 'Nej – dokumenterat ej aktuellt',
  'clo.pension.providerName': 'Pensionsleverantör (kontrollera för året)',
  'clo.pension.providerAnnualPremium': 'Premie för inkomståret (förslag från Plumme)',
  'clo.pension.providerPaidPremiums': 'Premie betald under kalenderåret (från Plumme)',
  'clo.pension.premiumDifference': 'Skillnad mellan dokumenterad premie och löneuppskattning',
  'clo.pension.paymentDifference': 'Skillnad mot registrerade premiebetalningar',
  'clo.pension.differenceExplanation': 'Förklaring och verifikationsreferenser för skillnader',
  'clo.pension.differenceHelp': 'Obligatoriskt vid skillnader. Förklara periodisering, justeringar och betalningar som bokförts på andra ställen med verifikationsreferenser. Oklara fel måste korrigeras innan du bekräftar avstämningen.',
  'clo.pension.noteSuggestions': 'Snabbkommentarer',
  'clo.pension.noteLabel.statementMissing': 'Årsbesked saknas',
  'clo.pension.noteLabel.statementCompared': 'Besked kontrollerat',
  'clo.pension.noteLabel.differenceToCheck': 'Avvikelse måste utredas',
  'clo.pension.noteLabel.paymentAfterYearEnd': 'Sen betalning',
  'clo.pension.noteLabel.noEmployees': 'Inga anställda',
  'clo.pension.noteLabel.belowThreshold': 'Under OTP-villkoren',
  'clo.pension.note.statementMissing': 'Årsbeskedet från pensionsleverantören har inte tagits emot. Avstämningen slutförs när det finns.',
  'clo.pension.note.statementCompared': 'Jag har jämfört anställda och premiebelopp i årsbeskedet med uppgifterna i Plumme.',
  'clo.pension.note.differenceToCheck': 'Det finns en skillnad mellan årsbeskedet och Plumme som måste utredas.',
  'clo.pension.note.paymentAfterYearEnd': 'Pensionspremie som betalats efter årsskiftet måste kontrolleras mot årsbeskedet.',
  'clo.pension.note.noEmployees': 'Jag har kontrollerat anställningsförhållandena för inkomståret. Företaget hade inga anställda.',
  'clo.pension.note.belowThreshold': 'Jag har kontrollerat anställningar och löner för inkomståret. Inget av villkoren för OTP-plikt var uppfyllt.',
  'clo.pension.documentationNote': 'Dokumentation och motivering',
  'clo.pension.documentationHelp': 'Valfritt: lägg till referens till årsbesked eller verifikation. Om OTP inte är aktuellt, förklara varför utifrån anställningsförhållandena under året.',
  'clo.pension.save': 'Spara OTP-bedömning',
  'clo.pension.saved': 'OTP-bedömningen har sparats. Du kan komma tillbaka och slutföra senare.',
  'clo.pension.saveError': 'Det gick inte att spara OTP-bedömningen.',
  'clo.pension.refresh': 'Läs in uppdaterat underlag',
  'clo.wealth.assetsHelp': 'Skattemässigt värde av anläggningstillgångar, inventarier och varulager som är bokförda vid årets slut.',
  'clo.wealth.sharesHelp': 'Aktier, andelar, fonder och andra finansiella investeringar som finns i råbalansen.',
  'clo.wealth.otherHelp': 'Övriga förmögenhetsposter som bankinsättningar, fordringar, mellanhavanden och andra tillgångar.',
  'clo.wealth.total': 'Summa förmögenhet',
  'clo.wealth.totalHelp': 'Summan av de förmögenhetsposter som Plumme kan läsa från bokföringen.',
  'clo.wealth.otherDebt': 'Övriga skulder',
  'clo.wealth.otherDebtHelp': 'Skuldposter på konto 2100-2999 från råbalansen per 31.12.',
  'clo.wealth.totalDebtHelp': 'Totala skulder per 31.12.',
  'clo.wealth.netHelp': 'Nettoförmögenhet är förmögenhet minus skulder.',
  'clo.wealth.assetsLongHelp': 'Skattemässigt värde av anläggningstillgångar (maskiner, inventarier, bilar), omsättningstillgångar och varulager som bolaget äger vid årets slut. För anläggningstillgångar används saldoavskrivning eller skattemässigt restvärde, inte redovisat bokfört värde.',
  'clo.wealth.sharesLongHelp': 'Aktier, andelar och andra värdepapper som bolaget äger. Enligt fritaksmetoden måste även aktier i dotterbolag tas med i förmögenheten. Värdet sätts normalt till anskaffningskostnad eller skattemässigt ingångsvärde, inte marknadsvärde.',
  'clo.wealth.otherLongHelp': 'Övriga förmögenhetsposter som inte är inventarier, varulager eller aktier — t.ex. banktillgodohavanden, kundfordringar, förutbetalda kostnader, momsfordran och mellanhavanden.',
  'clo.wealth.debtLongHelp': 'Allt bolaget är skyldigt per 31.12: banklån, checkkredit, leverantörsskulder, skatte- och momsskulder, utdelningsskuld, mellanhavanden med ägaren och andra kort- och långfristiga skulder.',
  'clo.addGainLossAccount': 'Lägg till vinst- och förlustkonto',
  'clo.ownerTransactions': 'Transaktioner mellan bolaget och personlig ägare',
  'clo.ownerLoanToOwner': 'Har bolaget gett lån, ställt säkerhet, sålt eller hyrt ut till ägare eller närstående?',
  'clo.ownerLoanFromOwner': 'Har ägare eller närstående gett lån, ställt säkerhet, sålt eller hyrt ut till bolaget?',
  'clo.editDetails': 'Ändra uppgifter',
  'clo.otherCompanyDetails': 'Övriga uppgifter om bolaget',
  'clo.otherCompanyDetailsHelp': 'Kontrollera att uppgifterna om ägande, koncernförhållanden och skattefria överföringar är korrekta.',
  'clo.ownership': 'Ägande',
  'clo.foreignOwnership': 'Har utländskt ägande eller har omorganiserats över landsgränser',
  'clo.wasSubsidiary': 'Var dotterbolag i en koncern under beskattningsåret',
  'clo.taxFreeTransfers': 'Har bolaget tagit emot eller överfört skattefria tillgångar eller förpliktelser',
  'clo.companyAndOwnership': 'Uppgifter om bolaget och ägande',
  'clo.fillSharesInfo': 'Fyll i alla uppgifter om aktier och investeringar',
  'clo.addShare': 'Lägg till aktie',
  'clo.addOtherInvestments': 'Lägg till andra investeringar',
  'clo.otherOperatingIncome': 'Övrig rörelseintäkt',
  'clo.totalOperatingIncome': 'Summa rörelseintäkt',
  'clo.goodsCost': 'Varukostnad',
  'clo.payrollCost': 'Lönekostnad',
  'clo.otherOperatingCost': 'Övrig rörelsekostnad',
  'clo.totalOperatingCost': 'Summa rörelsekostnad',
  'clo.financialIncome': 'Finansiell intäkt',
  'clo.financialCost': 'Finansiell kostnad',
  'clo.resultForYear': 'Årets resultat',
  'clo.equityAndDebt': 'Eget kapital och skulder',
  'clo.specification': 'Specifikation',
  'clo.inventoryValue': 'Värde på varulager',
  'clo.receivableTaxValue': 'Skattemässigt värde på fordran',
  'clo.equity': 'Eget kapital',
  'clo.payrollPensionSpec': 'Specifikation av löne- och pensionskostnad',
  'clo.addItem': 'Lägg till post',
  'clo.addItemHelp': 'Välj ett konto och lägg till en manuell ändring som bara gäller utkastet till skattemelding.',
  'clo.viewDetails': 'Visa detaljer',
  'clo.balanceDiscrepancy': 'Balansavvikelse',
  'clo.filing': 'Inlämning',
  'clo.readyForReview': 'Uppgifterna är redo för kontroll före inlämning.',
  'clo.checkBusinessInfo': 'Kontrollera näringsuppgifter',
  'clo.sendToAuthority': 'Skicka till Skatteetaten',
  'clo.taxReturnFiled': 'Skattemeldingen har skickats in och registrerats i Plumme.',
  'clo.cancelTaxReturn': 'Makulera och öppna skattemelding',
  'clo.taxReturnReopened': 'Skattemeldingen är öppnad för korrigering.',
  'clo.yearClosingRequiredTitle': 'Bokslutet måste slutföras först',
  'clo.yearClosingRequiredForTax': 'Skattemeldingen öppnas när räkenskapsåret har avslutats.',
  'clo.yearClosingRequiredForAnnual': 'Årsredovisningen öppnas när räkenskapsåret har avslutats.',
  'clo.yearClosingRequiredBody': 'Räkenskapsåret {year} kan avslutas tidigast 1 januari {nextYear}. Efter bokslutet är året låst för ändringar i bokföringen, och skattemelding och årsredovisning kan gås igenom.',
  'clo.goToYearClosing': 'Gå till bokslut',
  'clo.costsAndTax': 'Kostnader och skatt',
  'clo.assessment': 'Bedömning:',
  'clo.group': 'Koncern:',
  'clo.aboutAnnualAccounts': 'Om årsredovisningen',
  'clo.noAnnualAccountsDutyEnk': 'Ingen skyldighet att upprätta årsredovisning för ENK',
  'clo.accountantHelpAnnual': 'Hjälp från redovisningskonsult med att upprätta årsredovisningen',
  'clo.accountantHelpAnnualHelp': 'Använder bolaget en extern auktoriserad redovisningskonsult för att upprätta och lämna in årsredovisningen? Detta påverkar notupplysningarna om revision och redovisningskonsult.',
  'clo.yesAccountant': 'Ja, vi använder redovisningskonsult',
  'clo.noAccountant': 'Nej, vi använder inte redovisningskonsult',
  'clo.accountantHelpGeneral': 'Hjälp från redovisningskonsult generellt',
  'clo.accountantHelpGeneralHelp': 'Har bolaget fått hjälp av en extern auktoriserad redovisningskonsult med bokföringen under året? Detta skiljs från hjälp med att upprätta själva årsredovisningen.',
  'clo.yesGotHelp': 'Ja, vi har fått hjälp av redovisningskonsult',
  'clo.noGotHelp': 'Nej, vi har inte fått hjälp av redovisningskonsult',
  'clo.theFiling': 'Inlämningen',
  'clo.theCompany': 'Bolaget',
  'clo.contactEmails': 'E-post till kontaktpersoner',
  'clo.representativeName': 'Namn på en företrädare för bolaget',
  'clo.accountantAndAudit': 'Redovisningskonsult och revision',
  'clo.shouldBeAudited': 'Ska årsredovisningen revideras?',
  'clo.shouldBeAuditedHelp': 'Revisionsplikt gäller bolag över vissa gränsvärden. De flesta små AS är inte revisionspliktiga.',
  'clo.preparedByAccountant': 'Har årsredovisningen upprättats av en extern auktoriserad redovisningskonsult?',
  'clo.assistedByAccountant': 'Har bolaget fått hjälp av en extern auktoriserad redovisningskonsult?',
  'clo.operatingIncomeSection': 'Rörelseintäkter',
  'clo.salesIncome': 'Försäljningsintäkt',
  'clo.salesIncomeHelp': 'Fakturerad och bokförd omsättning exklusive moms.',
  'clo.totalOperatingIncome2': 'Summa rörelseintäkter',
  'clo.operatingCostSection': 'Rörelsekostnader',
  'clo.goodsCostHelp': 'Inköpta varor och direkta varukostnader bokförda på 4xxx-konton.',
  'clo.payrollCostHelp': 'Lön, arbetsgivaravgift och andra personalkostnader från 5xxx-konton.',
  'clo.depreciationFixedAssets': 'Avskrivning på materiella anläggningstillgångar',
  'clo.depreciationHelp': 'Årets redovisningsmässiga avskrivning hämtad från 60xx-konton.',
  'clo.totalOperatingCost2': 'Summa rörelsekostnader',
  'clo.operatingResult': 'Rörelseresultat',
  'clo.financialItems': 'Finansiella poster',
  'clo.otherInterestIncome': 'Övriga ränteintäkter',
  'clo.otherInterestCost': 'Övriga räntekostnader',
  'clo.netFinancial': 'Finansnetto',
  'clo.taxCost': 'Skattekostnad',
  'clo.taxCostHelp': 'Skattekostnaden hämtas från bokförda skattekostnadskonton när sådana finns.',
  'clo.resultAfterFinanceHelp': 'Årets resultat efter finansiella poster och bokförd skattekostnad.',
  'clo.transfersAndAllocations': 'Överföringar och dispositioner',
  'clo.totalTransfers': 'Summa överföringar och dispositioner',
  'clo.balanceAssets': 'Balansräkning - Tillgångar',
  'clo.fixedAssets': 'Anläggningstillgångar',
  'clo.noFixedAssets': 'Inga anläggningstillgångar i råbalansen.',
  'clo.totalFixedAssets': 'Summa anläggningstillgångar',
  'clo.currentAssets': 'Omsättningstillgångar',
  'clo.noCurrentAssets': 'Inga omsättningstillgångar i råbalansen.',
  'clo.totalCurrentAssets': 'Summa omsättningstillgångar',
  'clo.balanceEquityDebt': 'Balansräkning - Eget kapital och skulder',
  'clo.noEquityAccounts': 'Inga konton för eget kapital i råbalansen.',
  'clo.noDebtAccounts': 'Inga skuldkonton i råbalansen.',
  'clo.notes': 'Noter',
  'clo.assessmentType': 'Typ av bedömning',
  'clo.noUncertainty': 'Ingen osäkerhet',
  'clo.goingConcernUncertainty': 'Osäkerhet kring fortsatt drift',
  'clo.uncertaintyFreeText': 'Fritext för osäkerheten (läggs in i noten):',
  'clo.notePh': 'Skriv en kommentar/anteckning som ska följa med noten.',
  'clo.fteCount': 'Antal årsverken',
  'clo.noEmployees': 'Inga anställda',
  'clo.allInformation': 'Alla uppgifter',
  'clo.allInformationHelp': 'Gå igenom stegen till vänster. När allt är bekräftat kan dokumentpaketet förberedas.',
  'clo.continueToSigning': 'Gå vidare till signering',
  'clo.documentsHelp': 'Här är alla dokument som ska skapas och signeras som en del av årsredovisningen.',
  'clo.documentsSignerHelp': 'Styrelsen signerar protokollet från styrelsemötet och bolagsstämman. Både styrelsen och verkställande direktören signerar själva årsredovisningen.',
  'clo.docAnnualAccounts': 'Årsredovisning',
  'clo.docAnnualAccountsHelp': 'Årsredovisningen är färdigställd men måste signeras.',
  'clo.docBoardProtocol': 'Styrelseprotokoll',
  'clo.docBoardProtocolHelp': 'Protokollet från styrelsemötet.',
  'clo.docGeneralAssembly': 'Stämmoprotokoll',
  'clo.docGeneralAssemblyHelp': 'Protokollet från bolagsstämman.',
  'clo.tabOverview': 'Översikt',
  'clo.boardTabHelp': 'Här skapar du protokollet från styrelsemötet som hålls för att behandla årsredovisningen.',
  'clo.generalTabHelp': 'Här skapar du protokollet från bolagsstämman som godkänner årsredovisningen.',
  'clo.meetingDetails': 'Mötesdetaljer',
  'clo.meetingDate': 'Datum',
  'clo.meetingTime': 'Tid',
  'clo.meetingLocation': 'Plats',
  'clo.meetingLocationPh': 'Till exempel Oslo',
  'clo.attendees': 'Deltagare',
  'clo.attendeesHelp': 'Styrelsen är föreslagen. Ta bort den som inte deltog — protokollet anger bara att mötet var beslutsmässigt när majoriteten faktiskt var närvarande.',
  'clo.attendeesEmpty': 'Hämta rollerna från Enhetsregisteret i översikten först.',
  'clo.shareRegister': 'Aktieägare',
  'clo.shareRegisterHelp': 'Aktieägarna finns inte i något öppet register, så de förs in här. Listan används i stämmoprotokollet.',
  'clo.shareholderName': 'Namn',
  'clo.shares': 'Aktier',
  'clo.proxy': 'Företrädd av ombud',
  'clo.present': 'Närvarande',
  'clo.remove': 'Ta bort',
  'clo.addShareholder': 'Lägg till aktieägare',
  'clo.sharesPresent': 'Aktier närvarande',
  'clo.allocationTitle': 'Disposition av årets resultat för {year}',
  'clo.allocResult': 'Årets resultat efter skatt',
  'clo.allocDividend': 'Utdelning till ägare',
  'clo.allocRetained': 'Restbelopp som förs över till eget kapital',
  'clo.allocCovered': 'Restbelopp som täcks av eget kapital',
  'clo.protocolMissing': 'Saknas innan protokollet kan skapas: {fields}',
  'clo.missingDate': 'datum',
  'clo.missingLocation': 'plats',
  'clo.missingAttendees': 'deltagare',
  'clo.missingShareholders': 'aktieägare',
  'clo.missingShareholdersPresent': 'minst en aktieägare närvarande',
  'clo.generateProtocol': 'Skapa protokoll',
  'clo.protocolGenerating': 'Skapar protokoll…',
  'clo.protocolGenerated': 'Protokollet har skapats',
  'clo.protocolFailed': 'Kunde inte skapa protokollet.',
  'svc.protocolUnavailable': 'Protokollmodulen är inte inläst.',
  'clo.signersTitle': 'Vem ska signera',
  'clo.signersHelp': 'Namn och roller kommer från Enhetsregisteret. E-post finns inte där, så den måste du fylla i själv.',
  'clo.signersEmpty': 'Inga roller är registrerade än. Hämta dem från Enhetsregisteret för att komma igång.',
  'clo.signersMissingEmail': 'Signeringen kan inte skickas ut förrän alla har e-post: {names}',
  'clo.signerEmailPh': 'E-post för signering',
  'clo.rolesFetch': 'Hämta från Enhetsregisteret',
  'clo.rolesFetching': 'Hämtar…',
  'clo.rolesFetched': 'Roller hämtade från Enhetsregisteret',
  'clo.meetingChair': 'Mötesordförande',
  'clo.meetingChairHint': 'Mötesordföranden och ytterligare en person signerar protokollet, jf. aksjeloven § 5-16.',
  'clo.meetingChairNone': 'Inte vald — styrelsen signerar',
  'clo.docSentToEmail': 'Skickat för signering: {names}',
  'clo.docSendFailed': 'Kunde inte skicka för signering.',
  'clo.sendReminder': 'Skicka påminnelse',
  'clo.reminderSent': 'Påminnelse skickad till {names}',
  'clo.viewPdf': 'Visa PDF',
  'clo.sign': 'Signera',
  'clo.markSigned': 'Markera som signerad',
  'clo.docAwaitingSignature': 'Skickat för signering — väntar',
  'clo.docSigned': 'Signerad',
  'clo.docNotSigned': 'Inte signerad',
  'clo.docSentToast': '{document} skickat för signering',
  'clo.docSignedToast': '{document} markerat som signerat 🟣',
  'clo.signingHelp': 'Årsredovisningen måste signeras före inlämning. Signeringsstatus sparas på företaget.',
  'clo.signing': 'Signerar',
  'clo.continueToFiling': 'Gå vidare till inlämning',
  'clo.markAnnualSent': 'Lämna in årsredovisning',
  'clo.annualMarkedFiled': 'Årsredovisningen är markerad som inlämnad i Plumme.',
  'clo.cancelAnnualAccounts': 'Annullera och öppna årsredovisningen',
  'clo.annualReopened': 'Årsredovisningen har öppnats för korrigering.',
  'clo.backToStart': 'Tillbaka till start',
  'clo.yearClosed': 'Räkenskapsåret är avslutat',
  'clo.yearClosedHelp': 'Året är låst för ändringar. Du kan öppna det igen om du måste rätta något.',
  'clo.fileTaxReturn': 'Lämna in skattemeldingen',
  'clo.markTaxReturnFiled': 'Markera skattemeldingen som inlämnad',
  'clo.goToTaxReturn': 'Gå till skattemeldingen',
  'clo.openTaxReturn': 'Öppna skattemeldingen',
  'clo.fileAnnualAccounts': 'Lämna in årsredovisningen',
  'clo.markAnnualFiled': 'Markera årsredovisningen som inlämnad',
});
